export default __webpack_public_path__ + "static/03-SIN-LOGO-17669c847c1e086514b4d764276fbfd0.svg";